import * as Sentry from '@sentry/react';
import React from 'react';

export default function SentryBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={
        <div className="p-6 text-sm">Something went wrong. Our team has been notified.</div>
      }
      showDialog={false}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
